var LanguageSelector, changeUserLanguage,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

require('../../../../../core/frontend/groupon_modules/ariaKeyNavigation');

changeUserLanguage = require('../../../../../core/frontend/groupon_modules/changeUserLanguage');

module.exports = LanguageSelector = (function(superClass) {
  extend(LanguageSelector, superClass);

  function LanguageSelector() {
    this.trigger = $('#ls-lang-selected');
    if (this.trigger.length) {
      this.list = $('#ls-lang-list, #ls-lang-list-mobile, #ls-resp-lang-menu');
      this.links = this.list.find('.lang-list-item');
      this.$html = $('html');
      this.hovTimeout = 0;
      this.bind();
    }
  }

  LanguageSelector.prototype.bind = function() {
    var cancelTimer, startTimer;
    startTimer = (function(_this) {
      return function() {
        return _this.hovTimeout = setTimeout((function() {
          return _this.hideMenu();
        }), 150);
      };
    })(this);
    cancelTimer = (function(_this) {
      return function() {
        return clearTimeout(_this.hovTimeout);
      };
    })(this);
    this.list.on({
      'mouseenter': function() {
        cancelTimer();
      },
      'mouseleave': function() {
        startTimer();
      }
    });
    this.trigger.on({
      'mouseenter': (function(_this) {
        return function() {
          cancelTimer();
          _this.trigger.off('touchstart');
          if (!_this.list.is(':visible')) {
            _this.trigger.trigger('tap');
          }
        };
      })(this),
      'mouseleave': function() {
        startTimer();
      },
      'tap': (function(_this) {
        return function(e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          if (!_this.list.is(':visible')) {
            _this.showMenu();
            _this.setGlobalHideEvent();
          } else {
            _this.hideMenu();
          }
        };
      })(this)
    }).one('touchstart', (function(_this) {
      return function() {
        return _this.trigger.add(_this.list).off('mouseenter mouseleave');
      };
    })(this));
    this.initMenuNavigation(this.trigger, this.list, this.links);
    return this.links.on('click', function(e) {
      var language;
      e.preventDefault();
      e.stopImmediatePropagation();
      language = $(this).data('locale');
      return changeUserLanguage(language);
    });
  };

  LanguageSelector.prototype.showMenu = function() {
    this.trigger.addClass('ls-active');
    return this.list.attr('aria-hidden', 'false').show();
  };

  LanguageSelector.prototype.hideMenu = function() {
    this.list.attr({
      'aria-hidden': 'true'
    }).hide();
    return this.trigger.blur().removeClass('ls-active');
  };

  LanguageSelector.prototype.setGlobalHideEvent = function() {
    return this.$html.one('tap', (function(_this) {
      return function(e) {
        if (!$(e.target).closest('.lang-menu').length) {
          return _this.hideMenu();
        }
      };
    })(this));
  };

  return LanguageSelector;

})(Groupon.AriaMenuNavigation);

//# sourceMappingURL=data:application/json;base64,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
